var LanguageSelector, changeUserLanguage,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

require('../../../../../core/frontend/groupon_modules/ariaKeyNavigation');

changeUserLanguage = require('../../../../../core/frontend/groupon_modules/changeUserLanguage');

module.exports = LanguageSelector = (function(superClass) {
  extend(LanguageSelector, superClass);

  function LanguageSelector() {
    this.trigger = $('#ls-lang-selected');
    if (this.trigger.length) {
      this.list = $('#ls-lang-list, #ls-lang-list-mobile, #ls-resp-lang-menu');
      this.links = this.list.find('.lang-list-item');
      this.$html = $('html');
      this.hovTimeout = 0;
      this.bind();
    }
  }

  LanguageSelector.prototype.bind = function() {
    var cancelTimer, startTimer;
    startTimer = (function(_this) {
      return function() {
        return _this.hovTimeout = setTimeout((function() {
          return _this.hideMenu();
        }), 150);
      };
    })(this);
    cancelTimer = (function(_this) {
      return function() {
        return clearTimeout(_this.hovTimeout);
      };
    })(this);
    this.list.on({
      'mouseenter': function() {
        cancelTimer();
      },
      'mouseleave': function() {
        startTimer();
      }
    });
    this.trigger.on({
      'mouseenter': (function(_this) {
        return function() {
          cancelTimer();
          _this.trigger.off('touchstart');
          if (!_this.list.is(':visible')) {
            _this.trigger.trigger('tap');
          }
        };
      })(this),
      'mouseleave': function() {
        startTimer();
      },
      'tap': (function(_this) {
        return function(e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          if (!_this.list.is(':visible')) {
            _this.showMenu();
            _this.setGlobalHideEvent();
          } else {
            _this.hideMenu();
          }
        };
      })(this)
    }).one('touchstart', (function(_this) {
      return function() {
        return _this.trigger.add(_this.list).off('mouseenter mouseleave');
      };
    })(this));
    this.initMenuNavigation(this.trigger, this.list, this.links);
    return this.links.on('click', function(e) {
      var language;
      e.preventDefault();
      e.stopImmediatePropagation();
      language = $(this).data('locale');
      return changeUserLanguage(language);
    });
  };

  LanguageSelector.prototype.showMenu = function() {
    this.trigger.addClass('ls-active');
    return this.list.attr('aria-hidden', 'false').show();
  };

  LanguageSelector.prototype.hideMenu = function() {
    this.list.attr({
      'aria-hidden': 'true'
    }).hide();
    return this.trigger.blur().removeClass('ls-active');
  };

  LanguageSelector.prototype.setGlobalHideEvent = function() {
    return this.$html.one('tap', (function(_this) {
      return function(e) {
        if (!$(e.target).closest('.lang-menu').length) {
          return _this.hideMenu();
        }
      };
    })(this));
  };

  return LanguageSelector;

})(Groupon.AriaMenuNavigation);

//# sourceMappingURL=data:application/json;base64,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
